var LanguageSelector, changeUserLanguage,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

require('../../../../../core/frontend/groupon_modules/ariaKeyNavigation');

changeUserLanguage = require('../../../../../core/frontend/groupon_modules/changeUserLanguage');

module.exports = LanguageSelector = (function(superClass) {
  extend(LanguageSelector, superClass);

  function LanguageSelector() {
    this.trigger = $('#ls-lang-selected');
    if (this.trigger.length) {
      this.list = $('#ls-lang-list, #ls-lang-list-mobile, #ls-resp-lang-menu');
      this.links = this.list.find('.lang-list-item');
      this.$html = $('html');
      this.hovTimeout = 0;
      this.bind();
    }
  }

  LanguageSelector.prototype.bind = function() {
    var cancelTimer, startTimer;
    startTimer = (function(_this) {
      return function() {
        return _this.hovTimeout = setTimeout((function() {
          return _this.hideMenu();
        }), 150);
      };
    })(this);
    cancelTimer = (function(_this) {
      return function() {
        return clearTimeout(_this.hovTimeout);
      };
    })(this);
    this.list.on({
      'mouseenter': function() {
        cancelTimer();
      },
      'mouseleave': function() {
        startTimer();
      }
    });
    this.trigger.on({
      'mouseenter': (function(_this) {
        return function() {
          cancelTimer();
          _this.trigger.off('touchstart');
          if (!_this.list.is(':visible')) {
            _this.trigger.trigger('tap');
          }
        };
      })(this),
      'mouseleave': function() {
        startTimer();
      },
      'tap': (function(_this) {
        return function(e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          if (!_this.list.is(':visible')) {
            _this.showMenu();
            _this.setGlobalHideEvent();
          } else {
            _this.hideMenu();
          }
        };
      })(this)
    }).one('touchstart', (function(_this) {
      return function() {
        return _this.trigger.add(_this.list).off('mouseenter mouseleave');
      };
    })(this));
    this.initMenuNavigation(this.trigger, this.list, this.links);
    return this.links.on('click', function(e) {
      var language;
      e.preventDefault();
      e.stopImmediatePropagation();
      language = $(this).data('locale');
      return changeUserLanguage(language);
    });
  };

  LanguageSelector.prototype.showMenu = function() {
    this.trigger.addClass('ls-active');
    return this.list.attr('aria-hidden', 'false').show();
  };

  LanguageSelector.prototype.hideMenu = function() {
    this.list.attr({
      'aria-hidden': 'true'
    }).hide();
    return this.trigger.blur().removeClass('ls-active');
  };

  LanguageSelector.prototype.setGlobalHideEvent = function() {
    return this.$html.one('tap', (function(_this) {
      return function(e) {
        if (!$(e.target).closest('.lang-menu').length) {
          return _this.hideMenu();
        }
      };
    })(this));
  };

  return LanguageSelector;

})(Groupon.AriaMenuNavigation);

//# sourceMappingURL=data:application/json;base64,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
